module.exports = __webpack_public_path__ + "img/pass_good.52f0d513.svg";